import { Grid } from "@mui/material";
import React from "react";
import { formatOutput } from "../../../utils/computation/analysis";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";

function PairedTTestResult({ paired }) {
	// console.log({ paired });
	return (
		<div>
			<GraphHeader
				column={paired.column}
				dateTime={paired.dateTime}
				title={"Paired t"}
				analysisId={paired.id}
				additionals={{
					confidenceLevel: paired.confidenceLevel,
				}}
				graphs={paired.graphs}
			/>
			{paired.result === "Error" ? (
				<Grid
					container
					spacing={{ xs: 2, md: 3 }}
					columns={{ xs: 4, sm: 8, md: 12 }}
					sx={{ color: "#535353" }}>
					<Grid item xs={12}>
						<h3>{paired?.message || "An error occured"}</h3>
					</Grid>
				</Grid>
			) : (
				<Grid container>
					<Grid
						item
						container
						spacing={{ xs: 2, md: 3 }}
						columns={{ xs: 4, sm: 8, md: 12 }}
						sx={{ color: "#535353" }}>
						<Grid item xs={2.4} sm={2.4} md={2.4}>
							<h4>Data</h4>
							<h3>Column A</h3>
							<h3>Column B</h3>
							<h4 style={{ fontWeight: 800 }}>Paired Difference</h4>
						</Grid>
						<Grid item xs={2.4} sm={2.4} md={2.4}>
							<h4>N</h4>
							<h3>{paired?.arr1?.n || "N/A"}</h3>
							<h3>{paired?.arr2?.n || "N/A"}</h3>
							<h4 style={{ fontWeight: 800 }}>{paired.pairedDifference.n}</h4>
						</Grid>
						<Grid item xs={2.4} sm={2.4} md={2.4}>
							<h4>StDev</h4>
							<h3>{formatOutput(paired.arr1.std)}</h3>
							<h3>{formatOutput(paired.arr2.std)}</h3>
							<h4 style={{ fontWeight: 800 }}>{formatOutput(paired.pairedDifference.std)}</h4>
						</Grid>
						<Grid item xs={2.4} sm={2.4} md={2.4}>
							<h4>SE Mean</h4>
							<h3>{formatOutput(paired.arr1.statsem)}</h3>
							<h3>{formatOutput(paired.arr2.statsem)}</h3>
							<h4 style={{ fontWeight: 800 }}>{formatOutput(paired.pairedDifference.statsem)}</h4>
						</Grid>
						<Grid item xs={2.4} sm={2.4} md={2.4}>
							<h4>StMean</h4>
							<h3>{formatOutput(paired.arr1.mean)}</h3>
							<h3>{formatOutput(paired.arr2.mean)}</h3>
							<h4 style={{ fontWeight: 800 }}>{formatOutput(paired.pairedDifference.mean)}</h4>
						</Grid>

						<Grid item xs={12} sm={12} md={12}>
							<h4>95% CI for u_difference</h4>
							<h3>
								{"{ "}
								{paired.meanConfidenceInterval.map((ci, index) => {
									return index > 0 && formatOutput(ci) + ", ";
								})}
								{" }"}
							</h3>
							<h4>Note: u is the population difference of Column {paired.column}</h4>
						</Grid>

						<Grid item xs={6} sm={6} md={6}>
							<h4>Hypothesis Test</h4>
							<h4>Null hypothesis</h4>
							<h4>
								H<sub>0</sub>: U<sub>difference</sub> = 0
							</h4>
						</Grid>

						<Grid item xs={6} sm={6} md={6}>
							<br />
							<h4>Alternative hypothesis</h4>
							<h4>
								H<sub>1</sub>: U<sub>difference</sub> ≠ 0
							</h4>
						</Grid>

						<Grid item xs={3} sm={3} md={3}>
							<h4>T-Value</h4>
							<h3>{formatOutput(paired.pairedTtest.statistic)}</h3>
						</Grid>

						<Grid item xs={3} sm={3} md={3}>
							<h4>P-Value</h4>
							<h3>{formatOutput(paired.pairedTtest.pvalue)}</h3>
						</Grid>
					</Grid>
					<Grid item xs={12}>
						{" "}
						{paired.graphs.isBoxplot && paired.boxplotResult && (
							<ImageGraph
								url={paired.boxplotResult.groupBoxplot}
								title="Simple Boxplot"
								column={paired.column}
								// percent={result.inputs.confindence * 100}
								percent={95}
							/>
						)}
					</Grid>

					<Grid item xs={12}>
						{" "}
						{paired.graphs.isHistogram && paired.histogramResult && (
							<ImageGraph
								url={paired.histogramResult.histogram}
								title="Simple Histogram"
								column={paired.column}
								// percent={result.inputs.confindence * 100}
								percent={95}
							/>
						)}
					</Grid>

					<Grid item xs={12}>
						{paired.graphs.isIVP && paired.ivpResult && (
							<ImageGraph
								url={paired.ivpResult.individualPlot}
								title="Individual Value Plot"
								column={paired.column}
								// percent={result.inputs.confindence * 100}
								percent={95}
							/>
						)}
					</Grid>
				</Grid>
			)}
		</div>
	);
}

export default PairedTTestResult;
